import React, { useState, useRef, useEffect } from "react";
import queryString from "query-string";
import { Form, Progress, Alert } from "reactstrap";
import { CSSTransition } from "react-transition-group";
import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';

const LoginForm = (props) => {
  const { translate } = useLocalization();
  const parameters = queryString.parse(props.location.search);
  parameters.idp = "playhub";
  const ref = useRef();
  const usernameInputRef = useRef();
  const passwordInputRef = useRef();

  const [state, setState] = useState({
    onLogin: false,
    showForm: false,
    error: {
      open: false,
      message: "",
    },
    username: "",
    password: "",
  });

  useEffect(() => {
    setState(prev => ({ ...prev, showForm: true }));
  }, []);

  const onError = (error) => {
    setState(prev => ({
      ...prev,
      error: {
        open: true,
        message: error.message,
      },
    }));
  };

  const onSubmit = async (ev) => {
    ev.preventDefault();

    setState(prev => ({
      ...prev,
      onLogin: true,
      error: {
        open: false,
        message: "",
      },
    }));

    const usernameBase64 = btoa(`toolbox${usernameInputRef.current.value}`);

    try {
      const response = await props.api.userPassLogin(
        {
          username: usernameInputRef.current.value,
          password: passwordInputRef.current.value,
          usernameBase64
        },
        parameters
      );
      
      setState(prev => ({ ...prev, onLogin: false }));
      window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
    } catch (error) {
      const _translate = translate(error.errorCode);
      let message = translate("RequestLoginErrorMessage");

      if (_translate) {
        message = _translate;
      } else if (error.details) {
        message = error.details;
      }

      setState(prev => ({
        ...prev,
        onLogin: false,
        error: { open: true, message },
      }));
    }
  };

  return (
    <CSSTransition
      in={state.showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={ref}
      unmountOnExit
    >
      <div className="login-container" ref={ref}>
        <div className="login-head-playhub">
          <h1>{translate("ClientAuthentication")}</h1>
        </div>
        <div className="login-body">
          <Form onSubmit={onSubmit}>
            <div className="form-group">
              <label className="label-login-playhub">{translate("PlaceholderUserName")}</label>
              <input
                disabled={state.onLogin}
                className="form-control input-login-playhub"
                placeholder={translate("PlaceholderUserName")}
                ref={usernameInputRef}
                required={true}
                tabIndex={1}
                type="text"
                autoCorrect="off"
                autoCapitalize="none"
                name="username"
              />
            </div>
            <div className="form-group ">
              <label className="label-pass-playhub">{translate("PlaceholderPassword")}</label>
              <input
                className="form-control input-pass-playhub"
                placeholder={translate("PlaceholderPassword")}
                required={true}
                disabled={state.onLogin}
                ref={passwordInputRef}
                tabIndex={1}
                type="password"
                autoCorrect="off"
                autoCapitalize="none"
                name="password"
              />
            </div>
            {!state.onLogin ? (
              <div className="btn-container">
                <button type="submit" className="btn btn-play-hub" disabled={!props.turnstileSuccess}>
                  {translate("ButtonEnter")}
                </button>
              </div>
            ) : (
              <Progress animated color="danger" value={100} />
            )}
            <div className="messages-container">
              <Alert
                color="danger"
                id="error-message"
                isOpen={state.error.open}
                toggle={() => setState(prev => ({ ...prev, error: { open: false } }))}
              >
                {state.error.message}
              </Alert>
            </div>
            <props.TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />
          </Form>
        </div>
      </div>
    </CSSTransition>
  );
};

export default WithCaptcha(LoginForm, { useInsideForm: true, style: { marginTop: '2rem' } });
